import { KeyboardEvent, MutableRefObject } from 'react'
import { EventType } from '../../components/common/Input'

export const insertDataInGradeUpdate = <T>(
  event: EventType,
  tanksValues: Array<T>,
  setTanksValues: (tankValues: Array<T>) => void,
  setTanksInfoBorderColor?: (colorClassName: string) => void,
) => {
  const tank_id: string = event.id
  const name: string = event.name
  const preValue = event.value
  let value: null | number
  if (preValue === '') {
    value = null
  } else {
    value = Number(preValue)
  }
  const newTanksValues = [...tanksValues]
  const newTankValue = newTanksValues[Number(tank_id)]
  newTanksValues[Number(tank_id)] = {
    ...newTankValue,
    [name]: value,
  }
  setTanksValues(newTanksValues)
  if (setTanksInfoBorderColor) {
    setTanksInfoBorderColor('border-tdpldarkgrey border-opacity-60')
  }
}

export const keyDownChange = (
  event: KeyboardEvent<HTMLInputElement>,
  index: number,
  inputRefs: MutableRefObject<(HTMLInputElement | null)[]>,
) => {
  if (event.key === 'Enter') {
    inputRefs.current[index + 1]?.focus()
  }
}

export const continueJob = (onClose: () => void, onOpen: () => void) => {
  // Open the second modal first
  onOpen()

  // Use double RAF to ensure the second modal is fully painted before closing the first
  // First RAF queues for next frame, second RAF ensures it happens after paint
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      onClose()
    })
  })
}
